/* src/app/views/area-publica/home-page/saiba-mais-home/saiba-mais-home.component.scss */
:host ::ng-deep * > p,
:host ::ng-deep * > span,
:host ::ng-deep * > strong :host ::ng-deep * > a {
  text-align: left;
  font: normal normal normal 24px/34px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  color: #757575;
}
:host ::ng-deep .mat-button-wrapper div span {
  color: #FFFFFF;
}
.material-icons {
  font-family: "Material Icons", sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
:host ::ng-deep * > img {
  width: 120%;
  margin-left: -10%;
  border-radius: 8px;
}
#tipo-conteudo,
#label-leia-tambem {
  text-align: left;
  font: normal normal normal 24px/34px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #80BDE0;
  text-transform: uppercase;
  margin: 0;
  margin-left: 10px;
}
#nome-conteudo {
  text-align: left;
  font: normal normal bold 50px/52px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
#content-saiba-mais {
  margin: 0 20% 0 20%;
}
.btn-voltar-catalogo {
  text-align: center;
  font: normal normal normal 16px/30px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
}
.btn-voltar-catalogo,
.btn-voltar-catalogo > span {
  color: #007AC2;
}
.swiper {
  width: 600px;
  height: 300px;
}
.arrow-button {
  width: 45px;
  height: 45px;
  border: 1px solid #C2C4C6;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
}
.arrow-button span {
  margin: auto;
  display: block;
}
.item-carousel {
  padding: 20px 10px 20px 10px;
  margin: 10px;
}
#container-carousel {
  background-color: #FFFFFF;
  margin: 0 10% 20px 10%;
}
.item-carousel-line {
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px 0 10px;
}
:host ::ng-deep .content-margin {
  margin: 0;
}
:host ::ng-deep .ql-align-right {
  text-align: right;
}
:host ::ng-deep .ql-align-center {
  text-align: center;
}
:host ::ng-deep .ql-align-left {
  text-align: left;
}
/*# sourceMappingURL=saiba-mais-home.component.css.map */
